import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a747a19"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-box" }
const _hoisted_2 = { class: "contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_5 = { class: "infos" }
const _hoisted_6 = { class: "yellow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_head = _resolveComponent("home-head")!
  const _component_CurrentAddress = _resolveComponent("CurrentAddress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_html_footer = _resolveComponent("html-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_head),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CurrentAddress, null, {
          address: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" > 用户指南")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_empty, {
          "image-size": "400",
          image: require('@/assets/common/images/empty1.png'),
          description: "文章内容正在建设中",
          class: "empty"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                type: "primary",
                round: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("返回首页")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["image"])
      ])
    ]),
    _createVNode(_component_html_footer)
  ]))
}